import "../../../scss/lp/recruit-engineer.scss";

import $ from "jquery";
import { initHeroTypewriter } from "./hero-typewriter";
import { initMobileMenu } from "./mobile-menu";
import { initPageTop } from "./page-top";
import { initScrollActiveNav } from "./scroll-active-nav";
import { initHeroPastState } from "./hero-visibility-state";
import { initMvvCards } from "./scroll-mvv-cards";
import { initScrollProducts } from "./scroll-products";
import { initScrollStacks } from "./scroll-stacks";
import { initScrollBlog } from "./scroll-blog";
// import { initScrollMessage } from "./scroll-message";
import { initFigletLogo } from "./figlet-logo";

$(function () {
  initHeroTypewriter();
  initMobileMenu();
  initPageTop();
  initScrollActiveNav();

  // Hero通過状態をbody.is-past-heroに同期
  initHeroPastState({
    heroId: "hero",
    bodyClassName: "is-past-hero",
    leaveOffsetPx: 0,
    returnOffsetPx: 24,
  });
  initMvvCards();
  initScrollProducts();
  initScrollStacks();
  initScrollBlog();
  // initScrollMessage();
  initFigletLogo();
});
